import React, { useState, lazy, Suspense } from 'react';
import Modal from 'components/commons/modal';
import Loading from 'components/loading';

const PrivacyPolicyText = lazy(() => import('./privacy-policy-text'));

const PrivacyPolicyDialog: React.FC = () => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <a onClick={() => setOpened(true)}>política de privacidade</a>

            <Modal
                visible={opened}
                title="POLÍTICA DE PRIVACIDADE DA PLATAFORMA BIZCAPITAL"
                onClose={() => setOpened(false)}
            >
                <Suspense fallback={<Loading />}>
                    <PrivacyPolicyText />
                </Suspense>
            </Modal>
        </>
    );
};

export default PrivacyPolicyDialog;
